import { doc, updateDoc } from "firebase/firestore";
import { getDownloadURL, ref } from "firebase/storage";
import React, { useEffect } from "react";
import { uploadImageToStorage } from "../firebase/fireFuncs";
import db, { storage } from "../firebase/fireInit";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import BackgroundDiv from "../misc/elements/BackgroundDiv";
import Checkmark from "../misc/elements/Checkmark";
import MainStore from "../stores/MainStore";
import ActiveGoalDisplay from "./ActiveGoalDisplay";
import NoneSelectedHolder from "./NoneSelectedHolder";

const ActiveGoal = ({ setShowActiveGoal, handleActive }) => {
  const { player } = MainStore();

  return (
    <div
      style={{
        position: "absolute",
        right: "25%",
        marginTop: "20px",
        minWidth: "1150px",
        minHeight: "145px",
        maxWidth: "1px",
        width: "50%",
        height: "15%",
        zIndex: 3,
      }}
    >
      {player?.active.goal && (
        <ActiveGoalDisplay
          handleActive={handleActive}
          player={player}
          setShowActiveGoal={setShowActiveGoal}
        />
      )}
      {!player?.active.goal && (
        <NoneSelectedHolder setShowActive={setShowActiveGoal} from="Goal" />
      )}
    </div>
  );
};

export default ActiveGoal;
